import Vue from "vue";
Vue.config.devtools = true;
import Vuex from "vuex";
import axios from "axios";
import router from "@/router";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    idToken: null,
    userId: null,
    user: null,
    loading: false,
    color: "lightBlue",
    snackbarError: { show: false, msg: "" },
    dadosEmpresa: null
  },
  mutations: {
    authUser(state, userData) {
      state.idToken = userData.token;
      state.userId = parseInt(userData.userId);
    },
    storeUser(state, user) {
      state.user = user;
    },
    updateColor(state, color) {
      state.color = color;
      Vue.prototype.$vuetify.theme.primary = colors[color].base;
    },
    loadingStart(state) {
      state.loading = true;
    },
    clearUserData(state) {
      state.idToken = null;
      state.userId = null;
      state.user = null;
    },
    updateHeaderEmpresa(state, dadosEmpresa) {
      state.dadosEmpresa = dadosEmpresa;
    },
    loadingEnd(state) {
      state.loading = false;
    },
    showError(state, msg) {
      state.snackbarError.show = true;
      state.snackbarError.msg = msg;
    }
  },
  actions: {
    setLogoutTime({ dispatch }, expirationTime) {
      setTimeout(() => {
        dispatch("logout");
      }, expirationTime);
    },
    login({ commit, dispatch }, authData) {
      return new Promise((resolve, reject) => {
        axios
          .post("/auth/signIn", {
            login: authData.login,
            password: authData.password
          })
          .then(async res => {
            commit("authUser", {
              token: res.data.idToken,
              userId: res.data.id
            });
            commit("updateColor", res.data.color);
            const now = new Date();
            const expirationDate = new Date(res.data.expiresIn * 1000);
            localStorage.setItem("token", res.data.idToken);
            localStorage.setItem("userId", res.data.id);
            localStorage.setItem("color", res.data.color);
            localStorage.setItem("expirationDate", expirationDate);
            dispatch("setLogoutTime", expirationDate.getTime() - now.getTime());
            await dispatch("fetchUser");
            resolve(res);
          })
          .catch(error => {
            dispatch("logout");
            reject(error);
          });
      });
    },
    async autoLogin({ commit, dispatch }) {
      const token = localStorage.getItem("token");
      if (!token) return;
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      const now = new Date();
      if (now > expirationDate) return;
      const userId = localStorage.getItem("userId");
      if (!userId) return;
      const user = localStorage.getItem("user");
      if (!user) await dispatch("fetchUser");
      else commit("storeUser", JSON.parse(user));
      const color = localStorage.getItem("color");
      commit("updateColor", color);
      commit("authUser", {
        token: token,
        userId: userId
      });
      dispatch("setLogoutTime", expirationDate.getTime() - now.getTime());
    },
    fetchUser({ commit, state }) {
      return axios.get("/usuario/getById/" + state.userId).then(res => {
        const user = res.data;
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("color", user.color);
        commit("storeUser", user);
        commit("updateColor", user.color);
      });
    },
    changeColor({ commit }, empresa) {
      axios
        .put(`/empresa/changeColor/${empresa.idempresa}`, {
          color: empresa.color
        })
        .then(() => {
          localStorage.setItem("color", empresa.color);
          commit("updateColor", empresa.color);
        })
        .catch(error => error);
    },
    setHeaderEmpresa({ commit }, dadosEmpresa) {
      commit("updateHeaderEmpresa", dadosEmpresa);
    },
    logout({ commit }) {
      commit("clearUserData");
      commit("updateColor", "lightBlue");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("color");
      localStorage.removeItem("expirationDate");
      localStorage.removeItem("user");
      router.push("/login");
    }
  },
  getters: {
    userId(state) {
      return state.userId;
    },
    user(state) {
      return state.user;
    },
    isAuthenticated(state) {
      return state.idToken != null;
    },
    isAdmin(state) {
      if (!state.user) return false;
      return state.user.flgperfil == "G";
    },
    isLoading(state) {
      return state.loading;
    },
    snackbarError(state) {
      return state.snackbarError;
    },
    selectedColor(state) {
      return state.color;
    },
    isAccessExpired(state) {
      return state.user ? new Date() > new Date(state.user.datalimite) : true;
    },
    dadosEmpresa(state) {
      return state.dadosEmpresa;
    }
  }
});
